import React from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import {
  ConfigurationEmailConfirmationView,
  PageInConstructionView,
  VerifyContractView,
  BovedaView,
  AdministrateInvitedUsers
} from "../components/views";
import {
  RequestForContractAction,
  ContractRequestPanelAction,
  SignatureRequestAction,
  SignatureRequestDetailAction,
  SignatureReceivePanelAction,
  ProfileAction,
  ConfigurationPanelAction,
  ConfigurationSignatureHistoryAction,
  ConfigurationContractsHistoryAction,
  ConfigurationAdministrateAction,
  ConfigurationPlanRenovationAction,
  ConfigurationSignatureHistoryDetailAction,
  ConfigurationDomainsAction,
  TaxDataInvoincingAction,
  RequestInquiryDetailAction,
  CalligraphicExercisesReportDetailAction,
  ValidationSignedDocumentsDetailAction,
  RequestSignatureDetailAction,
  QueriesAndValidationsPanelAction,
  QueriesAndValidationsValidationSignedDocumentAction,
  SignatureRequestModuleAction,
  RequestDetailAction,
  RequestReliableSignatureAction,
  ChangePasswordEmailAction,
  SignatureRequestProfileAction,
  DocumentTrackingAction,
  QuestionnairesAdministrationAction,
  BusinessAdministrationAction,
  DigitalContractTemplateAction,
  FollowUpContractsAction,
  DocumentsToRequireAction,
  DigitalContractDashboardAction,
  QRDocSignedAction,
  FollowUpNewRecruiterAction,
  ContractingRegistrationAction,
  FollowUpActionsContractsActions,
  EditDocxAction,
  ContractRequestStatusAction,
  NegoiateContractAction,
  TeamNegotiationAction,
  GuestRepseDocumentsAction,
  HelpDeskAction,
  RepseStatusByCompanyAction,
  ValidateRepseDocumentAction,
  ContractorsCatalogAction,
  CustomizationAction,
  RepseStatusAction,
  NewSignatureDetailAction,
  DiscussionsAction,
  DigitalVaultAction,
  DigitalVaultFollowUpDocumentAction,
  DigitalVaultUploadAction,
  ValidateFreelanceAction,
  ProcedureAdministrationAction,
  MyFlowsAdministrationAction,
  ProfileAdministrationAction,
  SignatureBaseAction,
  ValidationSignatureBaseAction,
  ConsultNegotationAction,
  DigitalContractAction,
  InvitedWoutPasswordAction,
  UploadIdentityDocumentAction,
  DetailSignatureAction,
  AssembliesAction,
  ManageAssemblyAction,
  CreateDocumentsAction,
  RequestDocumentRedirectAction
} from "../components/actions";

import SignatureProfilesAction from "../components/actions/signature-profiles/signature-profiles.action";
import SignatureProfilesDetailsAction from "../components/actions/signature-profile-details/signature-profile-details.action";
import signRequestByVolumeAction from "../components/actions/sign-request-by-volume/sign-request-by-volume.action";
import userAdministrationAction from "../components/actions/user-administration/user-administration.action";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Cancel } from "../assets/logos/icons";
import { useTranslation } from "react-i18next";
import AssembliesDetailAction from "../components/actions/assemblies-detail/assemblies-detail.action";
//import userAdministrationAction from "../components/actions/user-administration/user-administration.action";
import AdministrationTypeOfDocumentsAction from "../components/actions/administration-types-of-documents/administration-types-of-documents.action";

const MyRoute = (props) => {
  let modules = localStorage.getItem("modules");
  modules = JSON.parse(modules);
  if (!modules || modules.length <= 0) return false;

  let validPath = false;
  for (let i = 0; i < modules.length; i++) {
    let { path } = modules[i].module;
    if (path === props.path) {
      validPath = true;
    }
  }
  return validPath === true ? <Route {...props} /> : null;
};

const Routes = (props) => {
  const { t } = useTranslation();
  const { onInvitedRedirectRegister } = props;
  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route
            exact={true}
            path="/request-document/:id"
            component={RequestDocumentRedirectAction}
          />
          <MyRoute
            exact={true}
            path="/change-password-user"
            component={ChangePasswordEmailAction}
          />
          <MyRoute
            exact={true}
            path="/signature-request-open"
            component={QRDocSignedAction}
          />
          <MyRoute
            exact={true}
            path="/"
            render={() => (
              <SignatureReceivePanelAction
                onInvitedRedirectRegister={onInvitedRedirectRegister}
              />
            )}
          />
          <MyRoute
            exact={true}
            path="/profile"
            component={ProfileAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/queries-and-validations"
            render={() => (
              <QueriesAndValidationsPanelAction
                onInvitedRedirectRegister={onInvitedRedirectRegister}
              />
            )}
          />
          <MyRoute
            exact={true}
            path="/sign-request"
            component={SignatureRequestAction}
          />
          <MyRoute
            exact={true}
            path="/detail/:id/:route"
            component={SignatureRequestDetailAction}
          />
          <MyRoute
            exact={true}
            path="/request/:id/:route"
            component={(props) => <RequestDetailAction {...props} />}
          />
          <MyRoute
            exact={true}
            path="/configuration"
            component={ConfigurationPanelAction}
          />
          <MyRoute
            exact={true}
            path="/configuration-signature-history"
            component={ConfigurationSignatureHistoryAction}
          />
          <MyRoute
            exact={true}
            path="/detailSignature/:id/:route"
            component={ConfigurationSignatureHistoryDetailAction}
          />
          <MyRoute
            exact={true}
            path="/configuration-contracts-history"
            component={ConfigurationContractsHistoryAction}
          />
          <MyRoute
            exact={true}
            path="/configuration-administer"
            component={ConfigurationAdministrateAction}
          />
          <MyRoute
            exact={true}
            path="/new-plan-renovation"
            component={ConfigurationPlanRenovationAction}
          />
          <MyRoute
            exact={true}
            path="/confirmation"
            component={ConfigurationEmailConfirmationView}
          />
          <MyRoute
            exact={true}
            path="/page-in-construction"
            component={PageInConstructionView}
          />
          <MyRoute
            exact={true}
            path="/waiting-authorization"
            component={VerifyContractView}
          />
          <MyRoute
            exact={true}
            path="/configuration-domain"
            component={ConfigurationDomainsAction}
          />
          <MyRoute
            exact={true}
            path="/request-inquiry-detail"
            component={RequestInquiryDetailAction}
          />
          <MyRoute
            exact={true}
            path="/request-signature-detail"
            component={RequestSignatureDetailAction}
          />
          <MyRoute
            exact={true}
            path="/calligraphic-exercise-report-detail"
            component={CalligraphicExercisesReportDetailAction}
          />
          <MyRoute
            exact={true}
            path="/autograph-signature-replicas"
            component={ValidationSignedDocumentsDetailAction}
          />
          <MyRoute
            exact={true}
            path="/tax-data-invoice/:id/:route"
            component={TaxDataInvoincingAction}
          />
          <MyRoute
            exact={true}
            path="/request-reliable-signature"
            component={RequestReliableSignatureAction}
          />
          <MyRoute
            exact={true}
            path="/queries-and-validations"
            component={QueriesAndValidationsPanelAction}
          />
          <MyRoute
            exact={true}
            path="/validation-signed-documents-detail"
            component={QueriesAndValidationsValidationSignedDocumentAction}
          />
          <MyRoute
            exact={true}
            path="/signature-profile"
            component={SignatureProfilesAction}
          />
          <MyRoute
            exact={true}
            path="/signature-profile-details"
            component={SignatureProfilesDetailsAction}
          />
          <MyRoute
            exact={true}
            path="/signature-profile-details/:id"
            component={SignatureProfilesDetailsAction}
          />
          <MyRoute
            exact={true}
            path="/signature-request-module"
            component={SignatureRequestModuleAction}
          />
          <MyRoute
            exact={true}
            path="/signature-request-profile/:id"
            component={SignatureRequestProfileAction}
          />
          <MyRoute
            exact={true}
            path="/document-tracking/:id"
            component={DocumentTrackingAction}
          />
          <MyRoute
            exact={true}
            path="/sign-request-by-volume"
            component={signRequestByVolumeAction}
          />
          <MyRoute
            exact={true}
            path="/contract-request"
            component={ContractRequestPanelAction}
          />
          <MyRoute
            exact={true}
            path="/digital-vault-grc"
            component={BovedaView}
          />
          <MyRoute
            exact={true}
            path="/digital-vault/:route"
            component={DigitalVaultAction}
          />
          <Route
            exact={true}
            path='/digital-vault-upload'
            component={DigitalVaultUploadAction}
          />
          <MyRoute
            exact={true}
            path="/questionnaire-administration"
            component={QuestionnairesAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/user-administration"
            component={userAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/business-administration"
            component={BusinessAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/digital-contract"
            component={DigitalContractTemplateAction}
          />
          <MyRoute
            exact={true}
            path="/documents-to-require"
            component={DocumentsToRequireAction}
          />
          <MyRoute
            exact={true}
            path="/followup-contracts"
            component={FollowUpContractsAction}
          />
          <MyRoute
            exact={true}
            path="/digital-contract-dashboard"
            component={DigitalContractDashboardAction}
          />
          <MyRoute
            exact={true}
            path="/contractor-registration/:id"
            component={ContractingRegistrationAction}
          />
          <MyRoute
            exact={true}
            path="/followup-actions-contracts/:solicitudeId/:contractWorkflowId"
            component={FollowUpActionsContractsActions}
          />
          <MyRoute
            exact={true}
            path="/contract-generation/:id"
            component={RequestForContractAction}
          />
          <MyRoute
            exact={true}
            path="/edit-docx/:clientContractId"
            component={EditDocxAction}
          />
          <MyRoute
            exact={true}
            path="/followup-new-recruiter/:requestId/:contractWorkflowId"
            component={FollowUpNewRecruiterAction}
          />
          <MyRoute
            exact={true}
            path="/negotiate-contract/:solicitudeId/:contractWorkflowId"
            component={NegoiateContractAction}
          />
          <MyRoute
            exact={true}
            path="/contract-request-status/:id"
            component={ContractRequestStatusAction}
          />
          <MyRoute
            exact={true}
            path="/team-negotiation"
            render={() => (
              <TeamNegotiationAction
                onInvitedRedirectRegister={onInvitedRedirectRegister}
              />
            )}
          />
          <MyRoute
            exact={true}
            path="/guest-repse-documents"
            component={GuestRepseDocumentsAction}
          />
          <MyRoute
            exact={true}
            path="/repse-status-by-company"
            component={RepseStatusAction}
          />
          <MyRoute exact={true} path="/help-desk" component={HelpDeskAction} />
          <MyRoute
            exact={true}
            path="/validate-repse-documents/:workflowExecutionId"
            component={ValidateRepseDocumentAction}
          />
          <MyRoute
            exact={true}
            path="/contractors-catalog/:id"
            component={ContractorsCatalogAction}
          />
          <MyRoute
            exact={true}
            path="/customization"
            component={CustomizationAction}
          />
          <MyRoute
            exact={true}
            path="/signature-detail/:id"
            component={NewSignatureDetailAction}
          />
          <MyRoute
            exact={true}
            path="/discussions"
            component={DiscussionsAction}
          />
          <MyRoute
            exact={true}
            path="/follow-up-registration-document/:id/:workflowExecutionId?"
            component={DigitalVaultFollowUpDocumentAction}
          />
          <MyRoute
            exact={true}
            path="/registration-user-freelance/:procedureUserId"
            component={ContractingRegistrationAction}
          />
          <MyRoute
            exact={true}
            path="/validate-user-freelance/:procedureUserId/:contractWorkflowId"
            component={ValidateFreelanceAction}
          />
          <MyRoute
            exact={true}
            path="/procedure-administration"
            component={ProcedureAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/my-flows-administration"
            component={MyFlowsAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/entities-administration"
            component={BusinessAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/request-base-signature"
            component={SignatureBaseAction}
          />
          <MyRoute
            exact={true}
            path="/validation-signature-base/:solicitudeId/:workflowExecutionId"
            component={ValidationSignatureBaseAction}
          />
          <MyRoute
            exact
            path="/administrate-invited"
            component={AdministrateInvitedUsers}
          />
          <MyRoute
            exact
            path="/consult-negotiation/:id/:workflowExecutionId"
            component={ConsultNegotationAction}
          />
          <MyRoute
            exact={true}
            path="/digital-contract/:route"
            component={CreateDocumentsAction}
          />
          <MyRoute
            exact={true}
            path="/digital-library/:route"
            component={DigitalContractAction}
          />
          <MyRoute
            exact
            path="/sign-request-open"
            component={InvitedWoutPasswordAction}
          />
          <MyRoute
            exact
            path="/upload-identity-document/:signRequestId"
            component={UploadIdentityDocumentAction}
          />
          <MyRoute
            exact
            path="/detail-signature-sign/:id"
            component={DetailSignatureAction}
          />
          <MyRoute
            exact
            path="/assemblies"
            component={AssembliesAction}
          />
          <MyRoute
            exact
            path="/detail-assembly/:assemblyId/:workflowExecutionId"
            component={AssembliesDetailAction}
          />
          <MyRoute
            exact
            path="/manage-assembly/:assemblyId/:workflowExecutionId"
            component={ManageAssemblyAction}
          />
          <MyRoute
            exact
            path='/document-types'
            component={AdministrationTypeOfDocumentsAction}
          />
        </Switch>
      </Router>
      {props.showError && (
        <Dialog
          title={"govo.digital"}
          onClose={() => props.setShowError(false)}
          width={256}
          height={280}
        >
          <p
            style={{
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            <img
              alt=""
              src={Cancel}
              style={{ marginTop: "10px", width: "55px", height: "55px" }}
            />
          </p>
          <p
            style={{
              textAlign: "center",
              margin: "auto",
              maxWidth: "300px",
            }}
          >
            {t("modalGlobalErrorMessage")}
          </p>
        </Dialog>
      )}
    </React.Fragment>
  );
};

export { Routes as default };
